import HomeIcon from '@mui/icons-material/Home';
import CodeIcon from '@mui/icons-material/Code';
import HtmlIcon from '@mui/icons-material/Html';
import CssIcon from '@mui/icons-material/Css';
import JavaScriptIcon from '@mui/icons-material/Javascript';
import PhpIcon from '@mui/icons-material/Php';
import WebIcon from '@mui/icons-material/Language';
import ComputerIcon from '@mui/icons-material/Computer';
import logo1 from '../../src/assets/logo.png'; 

export const logo = logo1;

export const categories = [
  { name: 'Coding', icon: <HomeIcon />, },
  { name: 'HTML', icon: <HtmlIcon />, },
  { name: 'CSS', icon: <CssIcon />, },
  { name: 'JavaScript', icon: <JavaScriptIcon/>, },
  { name: 'PHP', icon: <PhpIcon/>, },
  { name: 'React.js', icon: <CodeIcon />, },
  { name: 'Node.js', icon: <CodeIcon />, },
  { name: 'SQL', icon: <CodeIcon />, },
  { name: 'C Sharp', icon: <CodeIcon />, },
  { name: 'Web Development', icon: <WebIcon/>, },
  { name: 'App Development', icon: <ComputerIcon/>, },
];

export const demoThumbnailUrl = 'https://i.ibb.co/G2L2Gwp/API-Course.png';
export const demoChannelUrl = '/channel/UCmXmlB4-HJytD7wek0Uo97A';
export const demoVideoUrl = '/video/GDa8kZLNhJ4';
export const demoChannelTitle = 'JavaScript Mastery';
export const demoVideoTitle = 'Build and Deploy 5 JavaScript & React API Projects in 10 Hours - Full Course | RapidAPI';
export const demoProfilePicture = 'http://dergipark.org.tr/assets/app/images/buddy_sample.png'